export default "__VITE_ASSET__e40cdf39__"